/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_15 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_14 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/button/style/css';
import { ElTree as __unplugin_components_13 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/tree/style/css';
import { ElPopover as __unplugin_components_12 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/popover/style/css';
import { ElCheckboxGroup as __unplugin_components_11 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/checkbox-group/style/css';
import { ElRow as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/row/style/css';
import { ElCol as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/col/style/css';
import { ElCheckbox as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/checkbox/style/css';
import { ElTable as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/table/style/css';
import { ElPopconfirm as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/popconfirm/style/css';
import { ElSelect as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/option/style/css';
import { ElIcon as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/icon/style/css';
import { ElInput as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/input/style/css';
import { ElTableColumn as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/table-column/style/css';
import { ElTooltip as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/tooltip/style/css';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, isRef as _isRef } from "vue";
import _imports_0 from '../../assets/blk_default.jpg';
var _hoisted_1 = {
  class: "title",
  style: {
    "display": "flex"
  }
};
var _hoisted_2 = {
  style: {
    "text-align": "center"
  },
  class: "img_box"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  key: 1,
  src: _imports_0,
  alt: "",
  srcset: ""
};
var _hoisted_5 = {
  class: "tooltip-star"
};
var _hoisted_6 = {
  style: {
    "text-align": "center"
  }
};
var _hoisted_7 = {
  style: {
    "text-align": "center"
  },
  class: "img_box"
};
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  key: 1,
  src: _imports_0,
  alt: "",
  srcset: ""
};
var _hoisted_10 = {
  class: "tooltip-star"
};
var _hoisted_11 = {
  style: {
    "text-align": "center"
  }
};
var _hoisted_12 = {
  class: "contain"
};
var _hoisted_13 = {
  class: "com-inner"
};
var _hoisted_14 = {
  class: "com-title"
};
var _hoisted_15 = {
  class: "cateBox"
};
var _hoisted_16 = {
  class: "com-inner",
  style: {
    "margin-top": "5px",
    "border-top": "1px dashed #eee"
  }
};
var _hoisted_17 = {
  class: "com-title"
};
var _hoisted_18 = {
  class: "custom-tree-node"
};
var _hoisted_19 = {
  key: 0
};
var _hoisted_20 = {
  key: 1,
  class: "goods_list_all"
};
var _hoisted_21 = {
  class: "show_info"
};
var _hoisted_22 = {
  class: "dialog-footer"
};
import { useProductStore } from "@/store/product";
import { getTree } from "@/util/index";
import _ from "lodash";
import { nextTick, watch } from "vue";
import { product, product_class } from "@/api/apis";
import { debounce, isEqual } from "lodash";
export default {
  __name: 'goods-item',
  props: {
    showNa: {
      typeof: Boolean,
      default: false
    },
    goods: {
      typeof: Array
    },
    cate: {
      typeof: Array
    },
    is_show_relevance: {
      typeof: Boolean
    },
    isEdit: {
      typeof: Boolean,
      default: true
    },
    type: {
      typeof: String
    },
    showNa: {
      default: false
    }
  },
  emits: ["change_goods", "change_cate", "onBusiness", "onClue", "incomeChange", "comfirm"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var orderRateList = ref([{
      label: "<30%"
    }, {
      label: "30-60%"
    }, {
      label: "60-90%"
    }, {
      label: ">90%"
    }]);
    var product_store = useProductStore();
    // let props = defineProps(["goods", "is_show_relevance","isEdit"]);
    var props = __props;
    var emit = __emit;
    var goods_item_list = ref([]); // 关联的单个商品
    var goods_class_list = ref([]); // 关联的类别
    var type_list = ref([]); // 商品分类

    var defaultProps = {
      children: "children",
      label: "name",
      disabled: "disabled",
      isLeaf: "leaf"
    };

    // 关联产品
    var cate_list = ref([]);
    var checkCateList = ref([]);
    var checkeProList = ref([]);
    var getCheckList = () => {
      var _goods_class_list$val, _goods_item_list$valu;
      if ((_goods_class_list$val = goods_class_list.value) !== null && _goods_class_list$val !== void 0 && _goods_class_list$val.length) {
        var ids = Array.from(goods_class_list.value, _ref2 => {
          var {
            id
          } = _ref2;
          return id;
        });
        checkCateList.value = ids;
      } else {
        checkCateList.value = [];
      }
      if ((_goods_item_list$valu = goods_item_list.value) !== null && _goods_item_list$valu !== void 0 && _goods_item_list$valu.length) {
        var pro_ids = Array.from(goods_item_list.value, _ref3 => {
          var {
            id
          } = _ref3;
          return id;
        });
        checkeProList.value = pro_ids;
      } else {
        checkeProList.value = [];
      }
      setTimeout(() => {
        var _tree$value;
        (_tree$value = tree.value) === null || _tree$value === void 0 || _tree$value.setCheckedKeys(checkeProList.value, false);
      }, 0);
    };
    var tree = ref(null);
    var check_list_cate = ref([]);
    var check_list_goods = ref([]);
    var changeCheckList = (e, data, type) => {
      //type 1、分类 2、商品

      var arr = [];
      arr = type == 1 ? [...check_list_cate.value] : [...check_list_goods.value];
      var pro_list = arr.filter(item => {
        return item.id == data.id;
      });
      var pro_ids = Array.from(pro_list, _ref4 => {
        var {
          id
        } = _ref4;
        return id;
      });
      if (pro_ids.length) {
        if (!e) {
          arr = arr.filter(item => {
            return item.id != data.id;
          });
        }
      } else {
        if (e) {
          arr.unshift(data);
        }
      }
      if (type == 1) {
        check_list_cate.value = arr;
      } else {
        check_list_goods.value = arr;
      }
    };
    var loadNode = (node, resolve) => {
      if (node && node.data.children && node.data.children.length != 0) {
        resolve(node.data.children);
      } else {
        if (node.level == 0) {
          get_display_tree(cate_list.value);
          return resolve(cate_list.value);
        }
        if (node.level > 1) {
          product({
            category: node.data.id,
            page: 1,
            limit: 10
          }).then(res => {
            if (res.code == 200) {
              if (res.data.total > 10) {
                res.data.list.map(x => {
                  x.leaf = true;
                });
                return res.data.total;
              } else {
                res.data.list.map(x => {
                  x.leaf = true;
                });
                resolve(res.data.list);
              }
            }
          }).then(total => {
            // console.log("打印total====", total);
            product({
              category: node.data.id,
              page: 1,
              limit: total
            }).then(res => {
              if (res.code == 200) {
                resolve(res.data.list);
              }
            });
          });
        }
        if (node.data.name == "NA") {
          resolve([]);
        }
      }
    };
    var handleInput = (value, type, index) => {
      var regex = /^(\d+)?(\.\d{0,2})?$/;
      if (!regex.test(value)) {
        value = value.substring(0, value.length - 1);
        nextTick(() => {
          if (type == 1) {
            goods_item_list.value[index].income = value;
          } else {
            goods_class_list.value[index].income = value;
          }
        });
      }
    };
    var handle_goods = (value, type, index) => {
      if (value) {
        nextTick(() => {
          if (type == 1) {
            goods_item_list.value[index].income = parseFloat(value).toFixed(2);
          } else {
            goods_class_list.value[index].income = parseFloat(value).toFixed(2);
          }
        });
        emit("change_goods", goods_item_list.value);
      }
    };
    var handle_completion_rate = (value, type, row) => {
      if (value) {
        nextTick(() => {
          if (type == 1) {
            var index = goods_item_list.value.findIndex(item => item.id == row.id);
            goods_item_list.value[index].completion_rate = value;
          } else {
            var _index = goods_class_list.value.findIndex(item => item.id == row.id);
            goods_class_list.value[_index].completion_rate = value;
          }
        });
        emit("change_goods", goods_item_list.value);
      }
    };

    /**
     * 选中的节点
     */
    var handle_node = (val1, val2) => {
      tree.value.getCheckedNodes();
    };
    var handle_selected = () => {
      var _goods_item_list$valu2;
      goods_class_list.value = [...check_list_cate.value];
      goods_item_list.value = [...check_list_goods.value];
      if ((_goods_item_list$valu2 = goods_item_list.value) !== null && _goods_item_list$valu2 !== void 0 && _goods_item_list$valu2.length) {
        goods_item_list.value.forEach(item => {
          if (item.income) {
            item.income = item.income;
          } else if (item.price) {
            item.income = item.price;
          } else {
            item.income = "";
          }
          item.completion_rate = item.completion_rate || "";
        });
      }
      dialogVisible.value = false;
      try {
        emit("change_cate", goods_class_list.value);
        emit("change_goods", goods_item_list.value);
        emit("comfirm", {
          goods: goods_item_list.value,
          cate: goods_class_list.value
        });
      } catch (e) {
        // 事件未监听，忽略错误
      }
    };
    var debouncedFetch = debounce(obj => {
      var _cate_list$value;
      if ((_cate_list$value = cate_list.value) !== null && _cate_list$value !== void 0 && _cate_list$value.length) {
        handleUpdatedGoods();
      } else {
        product_class(obj).then(res => {
          var _res$data$data, _res$data;
          var data = (_res$data$data = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) !== null && _res$data$data !== void 0 ? _res$data$data : [];
          cate_list.value = data;
          handleUpdatedGoods();
        });
      }
    }, 300);
    var handleUpdatedGoods = () => {
      get_display_tree(cate_list.value);
      var updatedGoods = props.goods.map(item => {
        if (!item.bread_path && item.name != "NA") {
          var _item$cover_img_url;
          var tempId = item.category ? ((_item$cover_img_url = item.cover_img_url) === null || _item$cover_img_url === void 0 ? void 0 : _item$cover_img_url.id) || item.category : item.id;
          var treeList = getTree(cate_list.value, tempId);
          if (treeList && treeList.length > 0) {
            item.bread_path = treeList.map(node => node.name).join(" / ");
            if (item.category) {
              item.bread_path += " / " + item.name;
            }
          }
        }
        return item;
      });
      goods_item_list.value = updatedGoods;
    };
    /**
     * 监听父组件传来的商品列表
     */
    watch(() => {
      return props.goods;
    }, (val, oldVal) => {
      var obj = {
        pid: 75
      };
      if (props.showNa) {
        obj.isNA = 1;
      }
      console.log({
        val,
        oldVal
      }, _.isEqual(val, oldVal));
      if (!_.isEqual(val, oldVal)) {
        debouncedFetch(obj);
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => {
      return props.cate;
    }, val => {
      goods_class_list.value = val;
    }, {
      immediate: true,
      deep: true
    });
    var handle_open_select_goods = () => {
      getCheckList();
      check_list_goods.value = [...goods_item_list.value];
      check_list_cate.value = [...goods_class_list.value];
      dialogVisible.value = true;
    };
    /**
     * 删除商品
     */
    var handle_del = (type, row) => {
      if (type == "class") {
        var index = goods_class_list.value.findIndex(item => item.id === row.id);
        goods_class_list.value.splice(index, 1);
        emit("change_cate", [...goods_class_list.value]);
      } else if (type == "item") {
        var _index2 = goods_item_list.value.findIndex(item => item.id === row.id);
        goods_item_list.value.splice(_index2, 1);
        emit("change_goods", [...goods_item_list.value]);
      }
    };

    /**
     * 选择商品
     */

    var dialogVisible = ref(false);
    var key_word = ref("");

    /**
     * 将商品类别添加display属性
     */
    var get_display_tree = arr => {
      arr.map(x => {
        if (x.children && x.children.length != 0) {
          x.disabled = true;
          get_display_tree(x.children);
        }
      });
    };
    var select_goods_item = ref([]); // 选中的客户中的产品
    var select_goods_type = ref([]); // 选择的产品类别
    var good_item_table = ref(null);
    var good_class_table = ref(null);
    /**
     * 选择产品去关联商机线索
     */
    var handleSelectionChange = data => {
      select_goods_item.value = data;
      // 商品的选中data
    };
    var handleSelectionChange2 = data => {
      select_goods_type.value = data;
      // 商品分类的选中data
    };
    var handle_business = () => {
      var _good_item_table$valu, _good_class_table$val;
      emit("onBusiness", [...select_goods_item.value, ...select_goods_type.value]);
      (_good_item_table$valu = good_item_table.value) === null || _good_item_table$valu === void 0 || _good_item_table$valu.clearSelection();
      (_good_class_table$val = good_class_table.value) === null || _good_class_table$val === void 0 || _good_class_table$val.clearSelection();
    };
    var handle_clue = () => {
      var _good_item_table$valu2, _good_class_table$val2;
      emit("onClue", [...select_goods_item.value, ...select_goods_type.value]);
      (_good_item_table$valu2 = good_item_table.value) === null || _good_item_table$valu2 === void 0 || _good_item_table$valu2.clearSelection();
      (_good_class_table$val2 = good_class_table.value) === null || _good_class_table$val2 === void 0 || _good_class_table$val2.clearSelection();
    };
    /**
     * get_row
     */
    var get_row = row => {
      return row.id;
    };
    return (_ctx, _cache) => {
      var _component_el_tooltip = __unplugin_components_0;
      var _component_el_table_column = __unplugin_components_1;
      var _component_el_input = __unplugin_components_2;
      var _component_InfoFilled = _resolveComponent("InfoFilled");
      var _component_el_icon = __unplugin_components_3;
      var _component_el_option = __unplugin_components_4;
      var _component_el_select = __unplugin_components_5;
      var _component_el_popconfirm = __unplugin_components_6;
      var _component_el_table = __unplugin_components_7;
      var _component_Folder = _resolveComponent("Folder");
      var _component_el_checkbox = __unplugin_components_8;
      var _component_el_col = __unplugin_components_9;
      var _component_el_row = __unplugin_components_10;
      var _component_el_checkbox_group = __unplugin_components_11;
      var _component_Reading = _resolveComponent("Reading");
      var _component_el_popover = __unplugin_components_12;
      var _component_el_tree = __unplugin_components_13;
      var _component_el_button = __unplugin_components_14;
      var _component_el_dialog = __unplugin_components_15;
      var _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_cache[5] || (_cache[5] = _createTextVNode(" 关联产品/产品类别 ")), __props.isEdit ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "iconfont icon-tianjia",
        style: {
          "padding-left": "10px"
        },
        onClick: handle_open_select_goods
      })) : _createCommentVNode("", true), _createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: "新建线索",
        placement: "top"
      }, {
        default: _withCtx(() => [__props.is_show_relevance ? _withDirectives((_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "iconfont icon-xiansuoku",
          style: {
            "margin-left": "20px"
          },
          onClick: _withModifiers(handle_clue, ["stop"])
        }, null, 512)), [[_directive_permission, '1600::301']]) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: "新建商机",
        placement: "top"
      }, {
        default: _withCtx(() => [__props.is_show_relevance ? _withDirectives((_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "iconfont icon-shangji",
          style: {
            "margin-left": "10px"
          },
          onClick: _withModifiers(handle_business, ["stop"])
        }, null, 512)), [[_directive_permission, '1700::301']]) : _createCommentVNode("", true)]),
        _: 1
      })]), _createVNode(_component_el_table, {
        data: _unref(goods_item_list),
        style: {
          "width": "100%"
        },
        border: "",
        "header-row-style": {
          'text-align': 'center'
        },
        onSelect: handleSelectionChange,
        onSelectAll: handleSelectionChange,
        "row-key": get_row,
        ref_key: "good_item_table",
        ref: good_item_table
      }, {
        default: _withCtx(() => [__props.is_show_relevance ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 0,
          "reserve-selection": true,
          type: "selection",
          width: "55"
        })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
          prop: "",
          label: "产品",
          width: "180",
          "header-align": "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "",
            label: "图片",
            width: "180",
            "header-align": "center"
          }, {
            default: _withCtx(scope => {
              var _scope$row$cover_img_;
              return [_createElementVNode("div", _hoisted_2, [(_scope$row$cover_img_ = scope.row.cover_img_url) !== null && _scope$row$cover_img_ !== void 0 && _scope$row$cover_img_.cover_img_url ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: scope.row.cover_img_url.cover_img_url,
                alt: "",
                srcset: ""
              }, null, 8, _hoisted_3)) : (_openBlock(), _createElementBlock("img", _hoisted_4))])];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "Name",
            width: "240",
            "header-align": "center",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "product_number",
            label: "货号",
            width: "100",
            "header-align": "center",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "bread_path",
            label: "路径",
            "header-align": "center",
            "min-width": "260",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "price",
            label: "目录价",
            "header-align": "center",
            align: "center"
          }), __props.type == 'business' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            prop: "income",
            label: "预计收入",
            "header-align": "center",
            align: "center",
            width: "180"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.income,
              "onUpdate:modelValue": $event => scope.row.income = $event,
              autocomplete: "off",
              disabled: !__props.isEdit,
              type: "number",
              onInput: e => {
                handleInput(e, 1, scope.$index);
              },
              onBlur: $event => handle_goods(scope.row.income, 1, scope.$index)
            }, {
              prepend: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("￥")])),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onInput", "onBlur"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type == 'business' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            prop: "price",
            label: "成单率",
            "header-align": "center",
            align: "center",
            width: "200"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "dark",
              content: "",
              placement: "bottom-start"
            }, {
              content: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode(" 成单率<30% 机会很小；30-60% 客户没有明显倾向性，机会均等；"), _createElementVNode("br", null, null, -1), _createTextVNode("60-90% 客户倾向百林科，>90% 确定采购百林科")])),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_cache[8] || (_cache[8] = _createElementVNode("span", null, [_createElementVNode("i", {
                class: "red-star"
              }, "*"), _createTextVNode("成单率")], -1)), _createVNode(_component_el_icon, {
                class: "icon"
              }, {
                default: _withCtx(() => [_createVNode(_component_InfoFilled)]),
                _: 1
              })])]),
              _: 1
            })]),
            default: _withCtx(scope => [_createVNode(_component_el_select, {
              modelValue: scope.row.completion_rate,
              "onUpdate:modelValue": $event => scope.row.completion_rate = $event,
              class: "m-2",
              placeholder: "",
              style: {
                "width": "100%"
              },
              disabled: !__props.isEdit,
              onChange: e => {
                handle_completion_rate(e, 1, scope.row);
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderRateList), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.label,
                  label: item.label,
                  value: item.label
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.isEdit ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 2,
            label: "操作",
            width: "100",
            "header-align": "center"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_popconfirm, {
              title: "确认要删除此条数据？",
              onConfirm: $event => handle_del('item', scope.row)
            }, {
              reference: _withCtx(() => _cache[9] || (_cache[9] = [_createElementVNode("span", {
                class: "iconfont icon-shanchu"
              }, null, -1)])),
              _: 2
            }, 1032, ["onConfirm"])])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _cache[20] || (_cache[20] = _createElementVNode("div", {
        style: {
          "padding-bottom": "20px"
        }
      }, null, -1)), _createVNode(_component_el_table, {
        data: _unref(goods_class_list),
        style: {
          "width": "100%"
        },
        border: "",
        "header-row-style": {
          'text-align': 'center'
        },
        "row-key": get_row,
        onSelect: handleSelectionChange2,
        onSelectAll: handleSelectionChange2,
        ref_key: "good_class_table",
        ref: good_class_table
      }, {
        default: _withCtx(() => [__props.is_show_relevance ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 0,
          "reserve-selection": true,
          type: "selection",
          width: "55"
        })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
          prop: "",
          label: "产品类别",
          "min-width": "180",
          "header-align": "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "",
            label: "图片",
            width: "180",
            "header-align": "center"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", _hoisted_7, [typeof scope.row.cover_img_url == 'string' && scope.row.cover_img_url || typeof scope.row.cover_img_url == 'object' && scope.row.cover_img_url.cover_img_url ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: typeof scope.row.cover_img_url == 'string' && scope.row.cover_img_url ? scope.row.cover_img_url : scope.row.cover_img_url.cover_img_url,
              alt: "",
              srcset: ""
            }, null, 8, _hoisted_8)) : (_openBlock(), _createElementBlock("img", _hoisted_9))])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "Name",
            "header-align": "center",
            align: "center",
            "show-overflow-tooltip": ""
          }), __props.type == 'business' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            prop: "income",
            label: "预计收入",
            "header-align": "center",
            align: "center",
            width: "180"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.income,
              "onUpdate:modelValue": $event => scope.row.income = $event,
              autocomplete: "off",
              disabled: !__props.isEdit,
              type: "number",
              onInput: e => {
                handleInput(e, 2, scope.$index);
              },
              onBlur: $event => handle_goods(scope.row.income, 2, scope.$index)
            }, {
              prepend: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("￥")])),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onInput", "onBlur"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type == 'business' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            prop: "price",
            label: "成单率",
            "header-align": "center",
            align: "center",
            width: "200"
          }, {
            header: _withCtx(() => [_createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "dark",
              placement: "bottom-start"
            }, {
              content: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode(" 成单率<30% 机会很小；30-60% 客户没有明显倾向性，机会均等；"), _createElementVNode("br", null, null, -1), _createTextVNode("60-90% 客户倾向百林科，>90% 确定采购百林科")])),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_cache[12] || (_cache[12] = _createElementVNode("span", null, [_createElementVNode("i", {
                class: "red-star"
              }, "*"), _createTextVNode("成单率")], -1)), _createVNode(_component_el_icon, {
                class: "icon"
              }, {
                default: _withCtx(() => [_createVNode(_component_InfoFilled)]),
                _: 1
              })])]),
              _: 1
            })]),
            default: _withCtx(scope => [_createVNode(_component_el_select, {
              modelValue: scope.row.completion_rate,
              "onUpdate:modelValue": $event => scope.row.completion_rate = $event,
              class: "m-2",
              placeholder: "",
              style: {
                "width": "100%"
              },
              disabled: !__props.isEdit,
              onChange: e => {
                handle_completion_rate(e, 2, scope.row);
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderRateList), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.label,
                  label: item.label,
                  value: item.label
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.isEdit ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 2,
            label: "操作",
            width: "100",
            "header-align": "center"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_popconfirm, {
              title: "确认要删除此条数据？",
              onConfirm: $event => handle_del('class', scope.row)
            }, {
              reference: _withCtx(() => _cache[13] || (_cache[13] = [_createElementVNode("span", {
                class: "iconfont icon-shanchu"
              }, null, -1)])),
              _: 2
            }, 1032, ["onConfirm"])])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _unref(dialogVisible) ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "请选择关联产品/产品类别",
        style: {
          "width": "760px"
        },
        class: "select_dialog",
        "destroy-on-close": true
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handle_selected,
          color: "#248f83"
        }, {
          default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode(" 确定 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Folder)]),
          _: 1
        }), _cache[14] || (_cache[14] = _createElementVNode("text", {
          class: "txt"
        }, "选择产品类别", -1))]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_checkbox_group, {
          modelValue: _unref(checkCateList),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(checkCateList) ? checkCateList.value = $event : null),
          class: "cate"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cate_list), item => {
              return _openBlock(), _createBlock(_component_el_col, {
                span: 5,
                key: item.id,
                class: "cate-detail"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                  modelValue: item.id,
                  "onUpdate:modelValue": $event => item.id = $event,
                  label: item.id,
                  value: item.id,
                  onChange: e => {
                    changeCheckList(e, item, 1);
                  }
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "label", "value", "onChange"])]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          }), _cache[15] || (_cache[15] = _createElementVNode("div", null, null, -1))]),
          _: 1
        }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Reading)]),
          _: 1
        }), _cache[16] || (_cache[16] = _createElementVNode("text", {
          class: "txt"
        }, "选择产品", -1))])]), _createVNode(_component_el_tree, {
          props: defaultProps,
          load: loadNode,
          ref_key: "tree",
          ref: tree,
          "node-key": "id",
          lazy: "",
          "check-strictly": true,
          onCheckChange: handle_node
        }, {
          default: _withCtx(_ref5 => {
            var {
              node
            } = _ref5;
            return [_createElementVNode("span", _hoisted_18, [node.data.children ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(node.label), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_20, [node.data.id !== 0 ? (_openBlock(), _createBlock(_component_el_popover, {
              key: 0,
              placement: "right",
              width: 500,
              trigger: "hover"
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
                modelValue: _unref(checkeProList),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(checkeProList) ? checkeProList.value = $event : null)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                  modelValue: node.data.id,
                  "onUpdate:modelValue": $event => node.data.id = $event,
                  label: node.data.id,
                  onChange: e => {
                    changeCheckList(e, node.data, 2);
                  }
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(node.data.name), 1)]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "label", "onChange"])]),
                _: 2
              }, 1032, ["modelValue"])]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createElementVNode("table", null, [_cache[17] || (_cache[17] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", null, "名称"), _createElementVNode("th", null, "货号"), _createElementVNode("th", {
                style: {
                  "width": "80px"
                }
              }, "产品经理"), _createElementVNode("th", {
                style: {
                  "width": "70px"
                }
              }, "库存量"), _createElementVNode("th", {
                style: {
                  "width": "70px"
                }
              }, "价格")])], -1)), _createElementVNode("tbody", null, [_createElementVNode("tr", null, [_createElementVNode("td", null, _toDisplayString(node.data.name), 1), _createElementVNode("td", null, _toDisplayString(node.data.product_number), 1), _createElementVNode("td", null, _toDisplayString(node.data.manager_value), 1), _createElementVNode("td", null, _toDisplayString(node.data.inventory), 1), _createElementVNode("td", null, _toDisplayString(node.data.price), 1)])])])])]),
              _: 2
            }, 1024)) : (_openBlock(), _createBlock(_component_el_checkbox_group, {
              key: 1,
              modelValue: _unref(checkeProList),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(checkeProList) ? checkeProList.value = $event : null)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                modelValue: node.data.id,
                "onUpdate:modelValue": $event => node.data.id = $event,
                label: node.data.id,
                onChange: e => {
                  changeCheckList(e, node.data, 2);
                }
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(node.data.name), 1)]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "label", "onChange"])]),
              _: 2
            }, 1032, ["modelValue"]))]))])];
          }),
          _: 1
        }, 512)])]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true)]);
    };
  }
};